import { PopupManager } from 'managers/PopupManager'

function checkBalance() {
  const freeBetModel = game.models.FreebetsModel.get()
  if(freeBetModel.rest > 0){
    return  true
  }
  if (game.models.BetModel.getValue() > game.models.BalanceModel.get()) {
    PopupManager.show(game.models.BalanceModel.get() < game.models.BetModel.getMinValue() ? 'balanceTopUp' : 'balanceLow')
    return false
  }
  if (typeof game.models.BalanceModel.get() !== 'number' && isNaN(game.models.BalanceModel.get())){
    PopupManager.show('serverError')
    return false
  }
  return true
}

function checkBuyBalance() {
  const buyMultiplier = game.models.SpinModel.get().buy[0]
  if (game.models.BetModel.getValue() * buyMultiplier > game.models.BalanceModel.get()) {
    PopupManager.show(game.models.BalanceModel.get() < game.models.BetModel.getMinValue() * buyMultiplier ? 'balanceTopUp' : 'balanceLow')
    return false
  }
  return true
}

function selectNear() {
  game.models.BetModel.setNearest(game.models.BalanceModel.get())
}

export const SpinCheckService = {
  checkBalance,
  selectNear,
  checkBuyBalance,
}
